import { render, staticRenderFns } from "./ProjelerDuzenle.vue?vue&type=template&id=24b3b3c8&scoped=true&"
import script from "./ProjelerDuzenle.vue?vue&type=script&lang=js&"
export * from "./ProjelerDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./ProjelerDuzenle.vue?vue&type=style&index=0&id=24b3b3c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3b3c8",
  null
  
)

export default component.exports